(() => {
  'use strict';
  if (window.__genkiTrafficLoaded) return;
  window.__genkiTrafficLoaded = true;
  let sent = false;
  const event = crypto.randomUUID();
  function track() {
    if (sent || document.visibilityState !== 'visible') return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;
    if (/^\/(apps|account|checkouts|admin)(\/|$)/.test(location.pathname)) return;
    let session;
    try {
      const now = Date.now();
      let old = JSON.parse(sessionStorage.getItem('genki-traffic-session') || 'null');
      if (!old || now - old.at > 1800000 || !/^[a-f0-9-]{36}$/.test(old.id)) old = {id: crypto.randomUUID()};
      old.at = now;
      sessionStorage.setItem('genki-traffic-session', JSON.stringify(old));
      session = old.id;
    } catch (_) { session = crypto.randomUUID(); }
    sent = true;
    fetch('/apps/genkidama/shop-traffic', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({event, session, path: location.pathname.slice(0,300), consent: true})
    }).catch(() => {});
  }
  document.addEventListener('visitorConsentCollected', track);
  document.addEventListener('visibilitychange', track);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) track(); });
  }
  track();
})();
